import { render } from "./MaintenanceReminder.vue?vue&type=template&id=63ed6f62"
import script from "./MaintenanceReminder.vue?vue&type=script&lang=js"
export * from "./MaintenanceReminder.vue?vue&type=script&lang=js"
script.render = render

export default script